import imagesLoaded from 'imagesloaded';
import swiper from './slider.js';
import scrollAnimation from './scrollanimation.js';

const Snap = require(`imports-loader?this=>window,fix=>module.exports=0!snapsvg/dist/snap.svg.js`);
const DATA_NAME = "data-loading-";
const ANIMATION = DATA_NAME+"animation";
const PROGRESS = DATA_NAME+"progress";

class Loading {
  constructor(className,flg) {
    this.className = className;
    this.$el = $('.'+className);
    if(flg) {
      $('html').attr({[ANIMATION]:true,[PROGRESS]:'loading'});
      this.svg = Snap("#loading-logo");
      this.svgPath = this.svg.selectAll('path');
      this.svgAnimationEndFlg = false;
      this.svgPath.animate({ "fill-opacity": 0,"transform": 'translate(8px, 4px) scale(1.25)'},0);

      this.bodyLoaded = imagesLoaded('body');
      this.imageAllNum = this.bodyLoaded.images.length;
      this.imageNum = 0;
      this.progressPercentage = 0;

      this.bodyLoaded.on('progress', () => {
        this.imageNum++;
      });
      this.start();
    }else{
      scrollAnimation();
      $('html').attr({[ANIMATION]:false});
    }
  }
  start(){
    $(window).on('touchmove.noScroll', function(e) {
      e.preventDefault();
    });
    setTimeout(() => {
      this.animationSVG();
    },500);
    this.timer = setInterval(() => {
      this.check();
    }, 5);
  }
  check(){
    this.progressPercentage = (this.imageNum / this.imageAllNum) * 100;
    if(this.svgAnimationEndFlg === true && this.progressPercentage === 100){
      setTimeout(() => {
        this.finish();
      }, 500);
    }
  }
  async animationSVG(){
    for (let i = 0; i < this.svgPath.length; i += 1) {
      const result = await this.setTimerSVG(this.svgPath[i]);
    }
    this.svgAnimationEndFlg = true;
  }
  setTimerSVG(el){
    return new Promise(resolve => {
      setTimeout(() => {
        el.animate({"fill-opacity": 1,"transform": 'translate(0) scale(1)'}, 41, mina.ease,resolve);
      }, 41);
    })
  }
  finish(){
    clearInterval(this.timer);
    $('html').attr({[PROGRESS]:'complete'});
    this.svgPath.animate({ "fill-opacity": 0},600);
    setTimeout(() => {
      $('html').attr({[ANIMATION]:'false'});
      $(window).off('.noScroll');
      swiper.autoplay.start();
      scrollAnimation();
    }, 800);
  }

}
const currentid = 'speedheat';

if(window.name.indexOf( currentid ) == -1 && location.pathname == '/'){
  new Loading('js-loading',true);
  window.name = window.name + currentid;
  if(swiper.slides){
    swiper.autoplay.stop();
  }
}else{
  new Loading('js-loading',false);
}



